<template>
  <v-dialog v-model="dialog" max-width="80vw" max-height="90vh" scrollable>
    <v-card>
      <v-card-text>
        <div  class="pa-6">
          <template v-if="base64">
            <vue-pdf-embed v-if="type === 'application/pdf'" :source="uint8Array" style="max-width: 90%"  />
            <v-img v-else :src="base64" contain max-height="80vh" />
          </template>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        {{ filename }}
        <v-btn icon small @click="download" class="ml-3">
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn small @click="close">
          {{ $t('close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import Tools from "../../includes/tools";


export default {
  components: {
    VuePdfEmbed,
  },
  data() {
    return {
      dialog: false,
      filename: null,
      arrayBuffer: null,
      uint8Array: null,
      base64: null,
      type: null,
    }
  },


  methods: {
    open(arrayBuffer, type, filename) {
      this.type = type
      this.filename = filename
      this.arrayBuffer = arrayBuffer
      this.uint8Array = new Uint8Array(arrayBuffer)

      const blob = new Blob([arrayBuffer], { type: this.type })
      Tools.blobToBase64(blob).then((base64) => {
        this.base64 = base64
        this.dialog = true
      })


    },

    close() {
      this.dialog = false
    },

    download() {
      const blob = new Blob([this.arrayBuffer], { type: this.type })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = this.filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    }
  }
}
</script>

<style scoped lang="scss">

</style>